/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatGetWorkUnitsTrend } from "../funcs/chatGetWorkUnitsTrend.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { WorkUnitsTrendResult } from "../models/components/workunitstrendresult.js";
import {
  GetWorkUnitsTrendRequest,
  GetWorkUnitsTrendSecurity,
} from "../models/operations/getworkunitstrend.js";
import { unwrapAsync } from "../types/fp.js";
export type WorkUnitsTrendQueryData = WorkUnitsTrendResult;

export function prefetchWorkUnitsTrend(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetWorkUnitsTrendRequest | undefined,
  security?: GetWorkUnitsTrendSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWorkUnitsTrendQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWorkUnitsTrendQuery(
  client$: GramCore,
  request?: GetWorkUnitsTrendRequest | undefined,
  security?: GetWorkUnitsTrendSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<WorkUnitsTrendQueryData>;
} {
  return {
    queryKey: queryKeyWorkUnitsTrend({
      from: request?.from,
      to: request?.to,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function workUnitsTrendQueryFn(
      ctx,
    ): Promise<WorkUnitsTrendQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatGetWorkUnitsTrend(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWorkUnitsTrend(
  parameters: {
    from?: Date | undefined;
    to?: Date | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "getWorkUnitsTrend", parameters];
}
